<template>
    <div class="vsebina ">
        <div class="glava_vsebine adapt v-adapt">
            <div class="cols">
                <div class="col left grid-col-6">
                    <h1>KMG Pridelovalec</h1>
                </div>
                <div class="col right">
                </div>
            </div>
        </div>

        <div class="telo_vsebine adapt v-adapt">
            <div v-if="!pridelovalecid">
                NI PODATKOV
            </div>
            <div v-else>
                <div>
                    <div :style="{ display: 'inline-block' }">
                        Sezona
                        <br />
                        <dropdownlist :data-items="sezonePisanje" :text-field="'sezona'" @change="sezonaChange"
                            :value="dataSezona" />
                        <pridelovalec :pridelovalec="pridelovalec">
                        </pridelovalec>

                    </div>
                </div>
                <div class="uporabnik-spacer" style="margin-top:2rem"></div>
                <div class="">
                    <form @submit.prevent="handleSubmit" class="k-form">
                        <div class="form-group">
                            <div class="km-widget km-buttongroup k-widget k-button-group">
                                <button class="k-button k-primary" :disabled="pridelovalec.pisanje == 0"
                                    @click="saveData">Shrani</button>
                                <button class="k-button k-primary" @click="nazaj">Nazaj</button>
                            </div>
                        </div>

                        <div class="tb-col-lg-2 tb-col-sm-4 pt-1">

                            <fieldset class="left-border-for-children">
                                <div class="form-fieldset-header">
                                    <h2>Podatki o kmetiji</h2>
                                </div>

                                <label for="jeaktivna" class="k-form-field k-checkbox-field">
                                    <span>Je v kontroli (aktivna)</span>
                                    <input type="checkbox" :disabled="pridelovalec.pisanje == 0" v-model="jeaktivna"
                                        name="jeaktivna" id="jeaktivna" class="k-checkbox" />
                                </label>

                                <label for="kntst" class="k-form-field">
                                    <span>Kontrolna številka</span>
                                    <input type="text" :disabled="pridelovalec.pisanje == 0"
                                        v-model="pridelovalec.kontrolnastevilka" placeholder="Kontrolna številka"
                                        name="kntst" id="kntst" class="k-textbox" />
                                </label>

                                <label for="vezanareja" class="k-form-field k-checkbox-field">
                                    <span>Kmetija ima vezano rejo živali</span>
                                    <input type="checkbox" :disabled="pridelovalec.pisanje == 0" v-model="imavezanezivali"
                                        name="vezanareja" id="vezanareja" class="k-checkbox" />
                                </label>

                                <label for="travojedezivali" class="k-form-field k-checkbox-field">
                                    <span>Kmetija ima travojede živali</span>
                                    <input type="checkbox" :disabled="pridelovalec.pisanje == 0"
                                        v-model="imatravojedezivali" name="travojedezivali" id="travojedezivali"
                                        class="k-checkbox" />
                                </label>

                                <div class="display-flex">
                                    <label for="status" class="k-form-field flex-grow-1">
                                        <span>Status</span>
                                        <dropdownlist @change="spremeniStatus" name="status" :data-items="status"
                                            :text-field="'naziv'" :value="izbranStatus"
                                            :disabled="pridelovalec.pisanje == 0" />
                                    </label>

                                    <label for="statusDolocen" class="k-form-field">
                                        <span>Datum določitve statusa</span>
                                        <kendo-datepicker :disabled="pridelovalec.pisanje == 0" id="statusDolocen"
                                            :value="statusDolocen" @change="zamenjajDatum"
                                            :format="'dd.MM.yyyy'"></kendo-datepicker>
                                    </label>
                                </div>

                                <div class="k-form-field">
                                    <span>Vrsta pridelovalca / Aktivnosti</span>
                                    <kendo-multiselect :value="pridelovalec.vrstapridelovalca.filter(i=>i.sezona==sezona)" :data-items="vrsta"
                                        :text-field="'naziv'" :data-item-key="'id'" :placeholder="'Izberi vrsto'"
                                        id="vrstapridelovalca" @change="spremeniVrsto" :messages="multiselectmessages"
                                        :disabled="pridelovalec.pisanje == 0" :filterable="true" :auto-width="true">
                                    </kendo-multiselect>
                                </div>

                            </fieldset>

                            <fieldset class="left-border-for-children">
                                <div class="form-fieldset-header">
                                    <h2>Certificirane kategorije</h2>
                                </div>

                                <div class="kat_chk_list">
                                    <template v-for="kategorija in kategorije">
                                        <div
                                            :class="{ 'izbranakategorija': izbranekategorije.find(i => (i.id ? i.id : i) == kategorija.id) }">
                                            <input class="form-check-input" v-model="kategorijepridelovalca"
                                                type="checkbox" :value="kategorija.id" :id="'kat_chk_' + kategorija.id">
                                            <label class="form-check-label" :for="'kat_chk_' + kategorija.id">
                                                ({{ kategorija.sifra }}) {{ kategorija.naziv }}
                                            </label>
                                            <template v-if="kategorijepridelovalca.includes(kategorija.id)" v-for="vrstapridelave in kategorija.vrstapridelave">
                                                <div style="margin-left:50px;">
                                                    <input class="form-check-input" type="checkbox" v-model="kategorijepridelovalca"
                                                        :value="vrstapridelave.id"
                                                        :id="'kat_chk_' + kategorija.id + '_' + vrstapridelave.id">
                                                    <label class="form-check-label"
                                                        :for="'kat_chk_' + kategorija.id + '_' + vrstapridelave.id">
                                                        {{ vrstapridelave.naziv }}
                                                    </label>
                                                </div>
                                            </template>
                                          
                                        </div>
                                    </template>
                                </div>

                            </fieldset>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import PridelovalecKratko from './support/PridelovalecKratko';
export default {
    components: {
        'kendo-datepicker': DatePicker,
        'kendo-multiselect': MultiSelect,
        'dropdownlist': DropDownList,
        'pridelovalec': PridelovalecKratko
    },
    props: ['sezona', 'pridelovalecid'],
    data() {
        return {
            dataSezona: this.sezona,
            sezone: [],

            vrstapridelovalca: [], kmgmid: "", posta: "", postnastevilka: "", naslov: "", ime: "", priimek: "", telefon: "", email: "", opomba: "", postnastevilkakontakt: "", postakontakt: "", postnastevilkanosilec: "", postnanosilec: "", naslovkontakt: "", priimekkontakt: "", postanosilca: "", postnastevilkanosilca: "", emso: "", imekontakt: "", kntst: "",
            emailnosilca: "", telefonnosilca: "",


            password: '',
            submitted: false,
            multiselectmessages:
            {
                "singleTag": "izbrani elementi",
                "clear": "Počisti",
                "deleteTag": "Izbriši",
                "noData": "Ni podatkov"
            },
            vrsta: [],
            status: [],
            kategorije: [],
            statuskategorije: [],
            vrstapridelave: [{ id: "EK+K", naziv: "Ekološko z neekološko" }, { id: "EK-P", naziv: "Ekološko razen v obdobju preusmeritve" }, { id: "P", naziv: "Preusmeritev" }],
        }
    },

    computed: {
        izbranekategorije:
        {
            get() {

                let pridelava = null;

                if (this.pridelovalec?.vnesenekategorije)
                    return this.pridelovalec?.vnesenekategorije;
                else
                    return [];

            },

        },

        kategorijepridelovalca:
        {
            get() {



                if (this.pridelovalec?.izbranekategorije)
                    return this.pridelovalec.izbranekategorije.map(i => i.id);
                else
                    return [];

            },
            set(value) {

                //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
                //pridelava.kontrolnaStevilka=value;
                console.log("UPDATE CHKBOX");
                console.log(value);
                console.log()
                this.updateprop({ property: "izbranekategorije", value: value.map(i => { return { id: i, status: (this.statuskategorije[i]?.id) ? (this.statuskategorije[i]?.id) : "EK-P" } }) });
                //this.updateshemaprop({property:"kategorije",value:value.map(i=>{return {id:i,status:this.statuskategorije  [i]}})});
            }
        },
        imavezanezivali:
        {
            get() {

                return this.pridelovalec.imavezanezivali > 0 ? true : false;
            },
            set(value) {
                this.updateprop({ property: "imavezanezivali", value: value ? 1 : 0 });

            }
        },
        jeaktivna:
        {
            get() {

                return this.pridelovalec.jeaktivna > 0 ? true : false;
            },
            set(value) {
                this.updateprop({ property: "jeaktivna", value: value ? 1 : 0 });

            }
        },
        imatravojedezivali:
        {
            get() {

                return this.pridelovalec.imatravojedezivali > 0 ? true : false;
            },
            set(value) {

                this.updateprop({ property: "imatravojedezivali", value: value ? 1 : 0 });

            }
        },
        izbranStatus:
        {
            get() {

                return this.status.find(i => i.id == this.pridelovalec.statusid);
            },
            set(value) {
                this.updateprop({ property: "statusid", value: value.id });

            }
        },
        statusDolocen:
        {
            get() {

                return this.pridelovalec.datumdolocitvestatusa ? provideIntlService(this).parseDate(this.pridelovalec.datumdolocitvestatusa) : new Date();
            },
            set(value) {


                this.updateprop({ property: "datumdolocitvestatusa", value: value.toISOString() });
            }
        },
        ...mapState('users', ['sezonePisanje']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant', 'dataSezone'])

    },
    created() {
        this.dataSezona = { sezona: this.sezona };
        this.naloziPodatke();

    },
    methods: {

        ...mapActions({ naloziSifrant: 'sifrant/load' }),
        ...mapActions('pridelava', ['loadOne', 'save', 'loadIdPoSezoni']),
        ...mapMutations('pridelava', ['updateprop']),
        handlestatuskategorijechange(id, event) {

            //this.kategorijepridelovalca=this.kategorijepridelovalca.map(i=>{return {id:i,status:event.target.value [i]}});
            console.log("handlestatuskategorijechange");
            console.log(id);
            console.log(event.value);
            this.statuskategorije[id] = event.value;
            console.log(this.statuskategorije);
            this.updateprop({
                property: "izbranekategorije", value:
                    this.pridelovalec.izbranekategorije.map(i => { return { id: i.id, status: (this.statuskategorije[i.id]?.id) ? (this.statuskategorije[i.id]?.id) : "EK-P" } })
            });
            console.log(this.pridelovalec.izbranekategorije);
            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            /*var k=pridelava.kategorije.map(i=>{
                if (i.id==id)
                    return {...i,status:event.value};
                return i;   
            });
            console.log(k);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"kategorije",value:k});
            */


        },

        saveData(e) {

            //popravi vrstepredelovalca
            console.log("Shranjujem!!")
            console.log(this.pridelovalec.izbranekategorije)
            //console.log();
            this.pridelovalec.vrstapridelovalca=this.pridelovalec.vrstapridelovalca.filter(i=>i.sezona==this.sezona);
            let vp=this.pridelovalec.izbranekategorije;
            if(vp&&vp.length>0)
            this.pridelovalec.vrstapridelovalca.push(...vp);
            console.log(this.pridelovalec.vrstapridelovalca)
            this.save(this.dataSezona);
        },
        handleSubmit(e) {

            e.preventDefault();
        },
        cancel(e) {
            this.$router.go(-1)
        },
        spremeniVrsto(event) {
            this.updateprop({ property: "vrstapridelovalca", value: [...event.target.value] });

        },
        spremeniStatus(event) {
            this.izbranStatus = event.target.value;

        },
        zamenjajDatum(e) {
            console.log(e);
            this.statusDolocen = e.value;
        },

        naloziPodatke() {
            // this.dataSezona={sezona:this.sezona};
            // this.dataSezone
            //         this.sifrant["statuspridelovalca"]
            //       this.sifrant["vrstapridelovalca"]
            var thisComp = this;
            this.naloziSifrant({ sezona: this.dataSezona.sezona, sifrant: "vrstapridelovalca" }).then(() => {
                thisComp.vrsta = thisComp.sifrant["vrstapridelovalca"];
            });
            this.naloziSifrant({ sezona: this.dataSezona.sezona, sifrant: "statuspridelovalca" }).then(() => {
                thisComp.status = thisComp.sifrant["statuspridelovalca"];
            });
            this.naloziSifrant({ sezona: 0, sifrant: "vrstapridelovalca" }).then(() => {
                //TODO MAGIC!!!

                thisComp.kategorije = thisComp.sifrant["vrstapridelovalca"].reduce((a,c)=>{
                    let cat=JSON.parse(c.naziv);
                    let najden=a.find(i=>i.sifra==cat.id);
                    if(najden)
                        {
                            if(cat.nazivpridelave)
                            najden.vrstapridelave.push({id:c.id,naziv:cat.nazivpridelave});
                            else
                            najden.id=c.id;
                        }
                    else{
                        if(cat.nazivpridelave)
                            a.push({id:c.id,sifra:cat.id,naziv:cat.naziv,vrstapridelave:[{id:c.id,naziv:cat.nazivpridelave}]});
                        else
                            a.push({id:c.id,sifra:cat.id,naziv:cat.naziv,vrstapridelave:[]});
                    }
                    return a;
                },[]
            )
                //map(i => {let x=JSON.parse(i.naziv);x.did=i.id;return x; });
            });
            this.loadOne({ sezona: this.dataSezona.sezona, pridelovalecid: this.pridelovalecid }).then(()=>{

                if(!this.pridelovalec.izbranekategorije&&this.pridelovalec.vrstapridelovalca){
                   
                    Vue.set(this.pridelovalec,'izbranekategorije',this.pridelovalec.vrstapridelovalca.filter(v=>v.sezona==0));
                    console.log("delam!!")
                    console.log(this.pridelovalec.izbranekategorije);
                }

            })

        },
        sezonaChange(event) {


            const sezona = event.value;
            this.dataSezona = sezona;
            this.loadIdPoSezoni({ sezona: sezona.sezona, pridelovalecid: this.pridelovalecid }).then(pridelovalec => {
                this.pridelovalecid = pridelovalec.id;
                this.$router.push({ name: 'pridelovalec', params: { sezona: sezona.sezona, pridelovalecid: pridelovalec.id } });
                this.naloziPodatke();
            });


            //  this.naloziPodatke();



        },
    }
};
</script>

<style>
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}


.k-checkbox-field input[type="checkbox"] {
    margin-left: 0.5rem;

}
</style>